<template>
  <b-card no-body class="col-12 " v-if="item">
    <b-card-header :class="['p-1', 'treeItemHover']" header-tag="h5"
      :header-bg-variant="selected ? 'm-2 sale-rep-nav background-color-primary' : ''"
      :header-text-variant="selected ? 'white' : '' || highlightedTreeItem(item) ? 'success' : ''"
      @click="onItemSelected(entityObject, item)"
      @mouseenter="hovered = true"
      @mouseleave="hovered = false"
      :title="id">
      <b-button title="Open/Close" variant="link" size="sm" @click.stop="open = !open" v-if="hasChildren">
        <b-icon :icon="open ? 'chevron-down' : 'chevron-right'"></b-icon>
      </b-button>
      <b-button title="No Children" variant="link" size="sm" v-else>
        <b-icon icon="blank"></b-icon>
      </b-button>
      <b-badge variant="warning" v-if="item.Created">
        <b-icon icon="asterisk" aria-hidden="true"></b-icon>
      </b-badge>
      {{ getTitleByEntityObject(entityObject, item) }}
      <span v-if="selected || hovered" class="smaller float-md-right"><b-badge style="font-size: 10px">{{ entityObject.DisplayName }}</b-badge></span>
    </b-card-header>
    <b-collapse :visible="open" v-if="hasChildren">
      <b-card-body v-if="open">
        <b-row no-gutters style="width: 100%;">
          <tree-item v-for="(childItem, i) in item[childProperty.PropertyName]" :key="i"
            :item="childItem" :activeId="activeId" :activeEntityObjectId="activeEntityObjectId"
            @itemSelected="(entityObject, childItem, items) => onItemSelected(entityObject, childItem, items)"
            :childProperty="childPropertyNext"
            :childProperties="childPropertiesNext"
            :activeItemIds="activeItemIds"
            :entityObject="entityObjectNext"
            :searchTerm="searchTerm"
            :defaultActiveItem="defaultActiveItem"
            :defaultActiveEntityObject="defaultActiveEntityObject"
            :defaultActiveItemIds="defaultActiveItemIdsNext" />
        </b-row>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script lang="ts">
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'

import { EntityBase } from '@/store/types'
import LoadingText from '@/components/utility/loading-text.vue'

import MxEditorComponent from '@/mixins/editor-component'
import { EntityProperty, EntityObject } from '@/store/entity/types'

@Component({
  name: 'tree-item',
  components: {
    'loading-text': LoadingText,
  },
})
export default class extends Mixins(MxEditorComponent) {
  public open = false
  public hovered = false

  @Prop()
  public activeItem!: any

  @Prop()
  public item!: any

  @Prop()
  public activeId!: any

  @Prop()
  public activeEntityObjectId!: any

  @Prop()
  public childProperty!: EntityProperty

  @Prop()
  public childProperties!: EntityProperty[]

  @Prop({ default: () => [] })
  public activeItemIds!: any[] // a list of active items

  @Prop()
  public entityObject!: EntityObject

  @Prop()
  public searchTerm!: any

  @Prop()
  public defaultActiveItem!: any

  @Prop()
  public defaultActiveEntityObject!: any

  @Prop()
  public defaultActiveItemIds!: number[]

  @Prop()
  public defaultActiveItemId!: number

  public setOpenBasedOnActiveItemIds() {
    // TODO: this needs to know what level we're on when we have multiple levels!
    const { id, activeId, activeItemIds } = this
    // If this isn't the one that's selected, but is one that's a parent of the one that's selected
    if (id !== activeId && activeItemIds.some(activeItemId => activeItemId === id)) {
      // make sure it's open
      this.open = true
    }
  }

  public mounted() {
    const { hasChildren, onItemSelected, defaultActiveItemIdNext, defaultActiveId, id, defaultActiveEntityObject, entityObject, item } = this
    // TODO: OK, again, this only works if I know where the child is!
    // TODO: need that list of Ids to open things if needed
    if (hasChildren && defaultActiveItemIdNext === id) {
      this.open = true
    }
    if (defaultActiveEntityObject && defaultActiveEntityObject.EntityName === entityObject.EntityName) {
      if (defaultActiveId === id) {
        // this means this one is selected by Default!
        onItemSelected(entityObject, item)
      }
    }
    // at some point our activeItem may not ACTUALLY be selected and we need to make sure it is
    // because it could have been set pre-loading

    // OK, so this won't work
    // - because the children haven't actually loaded yet
    // - but that's why we OPEN them
    // but which gets this.open = true?
    // - we need the id list
    // - but the id list isn't set until we select an item
    // - but we can't select the item because we haven't got the id list yet!!!
    // - so I need to maybe set the whole activeId list from the start? Does that make sense?
    // if (!this.selected && this.activeItems && this.activeItems.length > 0 && this.activeItems[0] === this.item) {
    //   this.onItemSelected(this.entityObject, this.item)
    // }

    this.setOpenBasedOnActiveItemIds()
  }

  @Watch('activeItemIds')
  public activeItemIdsChanged() {
    this.setOpenBasedOnActiveItemIds()
  }

  @Watch('activeItem')
  public activeItemChanged() {
    this.setOpenBasedOnActiveItemIds()
  }

  // note: the item selected here may have come from a child, so it has to be passed
  public onItemSelected(entityObject: EntityObject, item: EntityBase, items: EntityBase[] = []) {
    // TODO: where and when to add my current item to the stack?
    // - first itneration yes or no?
    this.$emit('itemSelected', entityObject, item, [this.item, ...items])
  }

  get selected() {
    const { activeId, id, entityObject, activeEntityObjectId } = this
    return entityObject.EntityObjectId === activeEntityObjectId && activeId === id
  }

  // TODO: move this to another mixin above editor but below the fields?
  get id() {
    return this.getComponentIdByEntityObject(this.entityObject, this.item)
  }

  get defaultActiveId() {
    return this.defaultActiveItem && this.defaultActiveEntityObject ? this.getComponentIdByEntityObject(this.defaultActiveEntityObject, this.defaultActiveItem) : -1
  }

  get childList(): EntityBase[] {
    return this.childProperty ? this.item[this.childProperty.PropertyName] : []
  }

  public highlightedTreeItem(item: any) {
    if (!this.searchTerm || this.searchTerm.length === 0) {
      return false
    }

    const regex = new RegExp(this.searchTerm.toUpperCase())
    switch (this.editor.EditorName) {
      case 'ImageFolder': {
        return item.Images.some((img) => regex.test(img.ImageName.toUpperCase())) || item.ChildFolders.some((folder) => folder.Images.some((img2) => regex.test((img2.ImageName.toUpperCase()))))
      }
    }
  }

  get childPropertiesNext() {
    const { childProperties } = this
    if (childProperties && childProperties.length > 0) {
      return childProperties.slice(1)
    }
  }

  get childPropertyNext() {
    const { childProperties, childProperty } = this
    if (childProperties && childProperties.length > 0) {
      return childProperties[0]
    } else {
      return childProperty
    }
  }

  get entityObjectNext() {
    // TODO: get the child!
    const { entityObject, childProperty } = this
    if (childProperty) {
      const property = entityObject.Properties.find(p => p.EntityPropertyName === childProperty.EntityPropertyName)
      return property ? property.PropertyEntityObject : entityObject
    } else {
      return entityObject
    }
  }

  get defaultActiveItemIdsNext() {
    const { defaultActiveItemIds } = this
    if (defaultActiveItemIds && defaultActiveItemIds.length > 0) {
      return defaultActiveItemIds.slice(1)
    }
  }

  get defaultActiveItemIdNext() {
    const { defaultActiveItemIds, defaultActiveItemId } = this
    if (defaultActiveItemIds && defaultActiveItemIds.length > 0) {
      return defaultActiveItemIds[0] + ''
    } else {
      return defaultActiveItemId + ''
    }
  }

  get hasChildren() {
    return this.childList && this.childList.length > 0
  }
}
</script>
<style scoped>
.hide-not-visible .not-visible {
  display: none;
}

.treeItemHover:hover {
  background-color: #3C6188;
  color: white;
}
</style>
